/**
 * Allow using .sync from the outside and provide that property internal
 *
 * @property {string} name The name of the property
 * @returns {object} The mixin which can be used in a component
 */
export function vSync(name) {
	return {
		computed: {
			[name]: {
				get() {
					return this.$attrs[name];
				},
				set(value) {
					this.$emit(`update:${name}`, value);
				},
			},
		},
	};
}